import { render, staticRenderFns } from "./ImageResolver.vue?vue&type=template&id=e79c36d2&scoped=true&"
import script from "./ImageResolver.vue?vue&type=script&lang=js&"
export * from "./ImageResolver.vue?vue&type=script&lang=js&"
import style0 from "./ImageResolver.vue?vue&type=style&index=0&id=e79c36d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e79c36d2",
  null
  
)

export default component.exports